export const customizeHakuoshi = () => {
  document.addEventListener('DOMContentLoaded', function () {
    var regex = new RegExp('^[A-Za-z0-9.♡☆&]+$');
    var fullWidthRegex = /[^\x00-\x7Eｦ-ﾟ♡☆&]/g;
    var text_validation_element = document.querySelector('#text_validation2');
    var text_validation = "";
    if (text_validation_element) {
      text_validation = text_validation_element.value;
    }
    var color_validation_element = document.querySelector('#color_validation2');
    var color_validation = "";
    if (color_validation_element) {
      color_validation = color_validation_element.value;
    }
    var proceed_without_text_element = document.querySelector('#proceed_without_text2');
    var proceed_without_text = "";
    if (proceed_without_text_element) {
      proceed_without_text = proceed_without_text_element.value;
    }
    var inputs = [document.querySelector('#LettersForCustomization1'), document.querySelector('#LettersForCustomization2'), document.querySelector('#LettersForCustomization3')];
    var currentInput = null;

    // セッションストレージから値を取得して入力フィールドに表示する関数
    var setInputFieldValue = function setInputFieldValue(fieldId, sessionKey) {
      var storedValue = sessionStorage.getItem(sessionKey);
      if (storedValue) {
        document.querySelector(fieldId).value = storedValue;
      }
    };

    // 各入力フィールドに値をセット
    setInputFieldValue('#LettersForCustomization1', 'inputValue1');
    setInputFieldValue('#LettersForCustomization2', 'inputValue2');
    setInputFieldValue('#LettersForCustomization3', 'inputValue3');

    // セッションストレージに入力値を保存する
    var saveInputsToSessionStorage = function saveInputsToSessionStorage() {
      var inputValue1 = document.querySelector('#LettersForCustomization1').value.charAt(0).toUpperCase().replace(fullWidthRegex, '');
      var inputValue2 = document.querySelector('#LettersForCustomization2').value.charAt(0).toUpperCase().replace(fullWidthRegex, '');
      var inputValue3 = document.querySelector('#LettersForCustomization3').value.charAt(0).toUpperCase().replace(fullWidthRegex, '');
      var combinedLetters = inputs.map(function (input) {
        return input.value.charAt(0).replace(fullWidthRegex, '');
      }).join('').toUpperCase();

      // それぞれの入力値をセッションストレージに保存
      sessionStorage.setItem('inputValue1', inputValue1);
      sessionStorage.setItem('inputValue2', inputValue2);
      sessionStorage.setItem('inputValue3', inputValue3);
      sessionStorage.setItem('combinedLetters', combinedLetters);
    };
    document.querySelector('#LettersForCustomization1').addEventListener('input', saveInputsToSessionStorage);
    document.querySelector('#LettersForCustomization2').addEventListener('input', saveInputsToSessionStorage);
    document.querySelector('#LettersForCustomization3').addEventListener('input', saveInputsToSessionStorage);
    inputs.forEach(function (input) {
      input.addEventListener('focus', function () {
        currentInput = input;
      });
      input.addEventListener('input', function () {
        input.value = input.value.replace(fullWidthRegex, '');
        if (input.value.length > 1) {
          input.value = input.value.charAt(0);
        }
        input.value = input.value.toUpperCase();
        var combinedValue = inputs.map(function (input) {
          return input.value;
        }).join('');
        if (combinedValue.length > 3) {
          combinedValue = combinedValue.substring(0, 3);
          inputs.forEach(function (input, index) {
            input.value = combinedValue.charAt(index) || '';
          });
        }
        if (validateColorValue(color_validation)) {
          document.querySelector('#ColorForCustomizationError').textContent = '';
          if (!regex.test(combinedValue)) {
            document.querySelector('#LettersForCustomizationError2').textContent = text_validation;
            inputs.forEach(function (input) {
              return input.value = '';
            });
          }
        } else {
          inputs.forEach(function (input) {
            return input.value = '';
          });
        }
      });
      // バックスペースで文字を削除する場合の処理
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Backspace' || e.key === 'Delete') {
          input.value = '';
          saveInputsToSessionStorage();
        }
      });
    });
    var insertSymbol = function insertSymbol(symbol) {
      if (currentInput && validateColorValue(color_validation)) {
        var currentValue = currentInput.value.toUpperCase();
        if (currentValue.length < 1) {
          currentInput.value = currentValue + symbol;
          currentInput.dispatchEvent(new Event("input", {
            bubbles: true,
            cancelable: true
          }));
        }
        currentInput.focus();
      }
    };
    document.querySelector('#insertHeart').addEventListener('click', function (e) {
      e.preventDefault();
      insertSymbol('♡');
    });
    document.querySelector('#insertStar').addEventListener('click', function (e) {
      e.preventDefault();
      insertSymbol('☆');
    });
    document.querySelector('#insertAmp').addEventListener('click', function (e) {
      e.preventDefault();
      insertSymbol('&');
    });
    var colorOptions = document.querySelectorAll('.colorOption');
    var colorInput = document.querySelector('#ColorForCustomize');
    var selectColor = document.querySelector('#kokuinColor');
    // SessionStorageから選択色をロード
    var storedColor = sessionStorage.getItem('selectedColor');
    var openDrawer = document.querySelector('#openDrawerBtn');
    openDrawer.addEventListener('click', function () {
      if (storedColor) {
        colorOptions.forEach(function (option) {
          if (option.getAttribute('data-value') === storedColor) {
            option.classList.add('selected');
            colorInput.value = storedColor;
            selectColor.innerHTML = storedColor;
          }
        });
      } else {
        // デフォルトはゴールド
        var defaultColor = 'ゴールド';
        colorOptions.forEach(function (option) {
          if (option.getAttribute('data-value') === defaultColor) {
            option.classList.add('selected');
            colorInput.value = defaultColor;
            selectColor.innerHTML = defaultColor;
            sessionStorage.setItem('selectedColor', defaultColor);
          }
        });
      }
    });
    colorOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        colorOptions.forEach(function (opt) {
          return opt.classList.remove('selected');
        });
        option.classList.add('selected');
        colorInput.value = option.getAttribute('data-value');
        selectColor.innerHTML = colorInput.value;
        sessionStorage.setItem('selectedColor', colorInput.value);
        // 色選択の検証とエラーメッセージのクリア
        if (validateColorValue()) {
          document.querySelector('#ColorForCustomizationError').textContent = '';
        }
      });
    });
    var kokuinSubmit = document.querySelector('#kokuinSubmit');
    kokuinSubmit.addEventListener('click', function () {
      // セッションストレージから保存された値を取得
      var selectedColor = sessionStorage.getItem('selectedColor');
      var inputText = sessionStorage.getItem('combinedLetters');
      var kokuinBtnText = document.querySelector('#openDrawerText');
      var orderLetters = document.querySelector('#LettersForCustomize');
      var arrow = document.querySelector('.customize--arrow');
      orderLetters.value = inputText;
      if (selectedColor !== "" && selectedColor !== null && inputText !== "" && inputText !== null) {
        kokuinBtnText.innerHTML = "\u5165\u529B\u6587\u5B57\uFF1A".concat(inputText, "<span class=\"selectColorWrap\">\u9078\u629E\u8272\uFF1A<span class=\"selectColor\" data-value=\"").concat(selectedColor, "\" style=\"background-color: ").concat(selectedColor === "ゴールド" ? '#e6b422' : '#c0c0c0', ";\"></span></span>");
        arrow.style.display = 'none';
      } else {
        kokuinBtnText.textContent = "";
        arrow.style.display = 'block';
      }
    });
    var resetButton = document.querySelector('#resetButton');
    resetButton.addEventListener('click', function () {
      sessionStorage.setItem('inputValue1', "");
      sessionStorage.setItem('inputValue2', "");
      sessionStorage.setItem('inputValue3', "");
      sessionStorage.setItem('combinedLetters', "");
      sessionStorage.setItem('selectedColor', "");
      selectColor.innerHTML = "";
    });
  });
};

function validateColorValue(errormessage) {
  const colorInput = document.querySelector('#ColorForCustomize');
  const colorError = document.querySelector('#ColorForCustomizationError');
  if (colorInput.value === '') {
    colorError.textContent = errormessage;
    colorInput.focus();
    return false;
  }
  return true;
}
